/**
 * Shown when this tab is running an older build than the server serves.
 * Deliberately not a modal: nothing here is urgent enough to block a foreman
 * mid-triage, but it must be impossible to miss, because until it is taken
 * every label on screen is potentially yesterday's.
 */
import { useTranslation } from "react-i18next";
import { useNewVersion } from "@/hooks/useNewVersion";

export function NewVersionBanner() {
  const stale = useNewVersion();
  const { t } = useTranslation();
  if (!stale) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 pointer-events-none flex justify-center"
    >
      <div className="pointer-events-auto max-w-xl w-full bg-white border border-sky-300 shadow-lg rounded-xl px-4 py-3 flex items-center gap-3">
        <span aria-hidden className="text-lg leading-none">🔄</span>
        <div className="flex-1 text-sm">
          <div className="font-semibold text-slate-900">{t("common.newVersion.title")}</div>
          <div className="text-slate-600">{t("common.newVersion.body")}</div>
        </div>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="shrink-0 bg-sky-600 hover:bg-sky-700 text-white text-sm font-semibold rounded-lg px-4 py-2"
        >
          {t("common.refresh")}
        </button>
      </div>
    </div>
  );
}

export default NewVersionBanner;
